import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import mainMenuJson from '#data/mainMenu.json'
import MenuItem from './MenuItem'
import {useI18n} from '#hooks/useI18n'
import useUserModuleSettings from '#hooks/useUserModuleSettings'
import {usePermissions} from '#hooks/usePermissions'

function userHasRequiredRole(link, role) {
  return !link.role || link.role.indexOf(role) >= 0
}

function moduleIsVisibleForUser(showModule, menuItem) {
  if (!menuItem.modul) {
    return true
  }
  return showModule(menuItem.modul)
}

function getMenuItemsFromModuleSettings(menuItemsForRole, showModule) {
  return menuItemsForRole.filter(menuItem => moduleIsVisibleForUser(showModule, menuItem))
}

function createMenuItemsForUser(role, permissions, showModule) {
  const menuItemsForRole = mainMenuJson.links.filter(link => userHasRequiredRole(link, role))
  const menuItemsForUser = !permissions.allModulesVisible
    ? getMenuItemsFromModuleSettings(menuItemsForRole, showModule)
    : menuItemsForRole
  return menuItemsForUser
}

function hasSameBasePath(url, pathname) {
  return url.split('/')[1] === pathname.split('/')[1]
}

const useMainMenu = (role, permissions, showModule) => {
  const [menuItems, setMenuItems] = useState(mainMenuJson.links)

  useEffect(() => {
    const menutItemsForUser = createMenuItemsForUser(role, permissions, showModule)
    setMenuItems(menutItemsForUser)
  }, [role, showModule, permissions])

  return menuItems
}

function MainMenu({role, pathname}) {
  const {showModule} = useUserModuleSettings()
  const permissions = usePermissions()
  const menuItems = useMainMenu(role, permissions, showModule)

  if (!menuItems) {
    return null
  }

  const i18n = useI18n()
  return (
    <ul data-menu="main" className="menu__level">
      {menuItems.map(link => {
        const {url} = link
        return (
          <li key={url} className="menu__item">
            <MenuItem url={url} active={hasSameBasePath(url, pathname)} text={i18n.t(link.text)} />
          </li>
        )
      })}
    </ul>
  )
}

MainMenu.propTypes = {
  pathname: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
}

export default MainMenu
